/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Tab_BrokersInputs */

const cs_ebr_tab_brokers = /** @type {(inputs: Ebr_Tab_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři`)
};

const en_ebr_tab_brokers = /** @type {(inputs: Ebr_Tab_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers`)
};

/**
* | output |
* | --- |
* | "Brokers" |
*
* @param {Ebr_Tab_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_tab_brokers = /** @type {((inputs?: Ebr_Tab_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Tab_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_tab_brokers(inputs)
	return cs_ebr_tab_brokers(inputs)
});